import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/Authentication/";
    return {
        ValidateToken(request) {
            var url = baseUrl + "ValidateToken";
            return Proxy.Post(url, request);
        }
    };
})()